function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.8082 19.3204C29.7255 12.6814 24.9013 7.6973 19.1059 7.6973C14.5045 7.6973 10.5082 10.8532 8.51803 15.4717C3.72564 16.0875 0 20.9946 0 26.9408C0 33.3104 4.2829 38.4869 9.55293 38.4869H30.2509C34.6453 38.4869 38.2117 34.1764 38.2117 28.8652C38.2117 23.7849 34.9478 19.6668 30.8082 19.3204Z",
  fill: "#00A759"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2509 34.6382H9.55288C6.03422 34.6382 3.18427 31.1936 3.18427 26.9408C3.18427 22.9959 5.62026 19.7053 8.85233 19.3012L10.5559 19.0895L11.352 17.2613C12.8646 13.7398 15.826 11.546 19.1058 11.546C23.2773 11.546 26.8755 15.1253 27.6875 20.0709L28.1652 22.9574L30.6012 23.1691C33.0849 23.3615 35.0274 25.8824 35.0274 28.8652C35.0274 32.0404 32.8779 34.6382 30.2509 34.6382Z",
  fill: "#A0D2BB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7372 25.0165H16.7971V30.7896H21.4144V25.0165H25.4744L19.1058 17.3191L12.7372 25.0165Z",
  fill: "#00A759"
});

var SvgIcUploadImage = function SvgIcUploadImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcUploadImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_uploadImage.291a2505.svg";
export { ForwardRef as ReactComponent };